//@ts-ignore
import('./bootstrap');
